import React from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const [pendingCount, setPendingCount] = React.useState(0);
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const navigate = useNavigate();

  const fetchPendingCount = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:8080"}/api/admin/orders/pending-count`, {
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });
      
      if (!response.ok) {
        // Silent fail if not found or unauthorized
        return;
      }

      const data = await response.json();
      if (data.count !== undefined) {
        setPendingCount(data.count);
      }
    } catch (error) {
      // Don't log if it's just a network error or missing route
    }
  };

  React.useEffect(() => {
    fetchPendingCount();
    // Poll every 30 seconds for new orders
    const interval = setInterval(fetchPendingCount, 30000);
    return () => clearInterval(interval);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const menuItems = [
    { to: "/admin", label: "Dashboard", icon: "dashboard", svg: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /> },
    { to: "/admin/revenue", label: "Doanh thu & Lợi nhuận", isMaterial: true, iconName: "monitoring" },
    { to: "/admin/products", label: "Sản phẩm", icon: "inventory_2", svg: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" /> },
    { to: "/admin/popular", label: "Yêu thích nhất", isMaterial: true, iconName: "favorite" },
    { to: "/admin/orders", label: "Đơn hàng", icon: "receipt_long", badge: pendingCount, svg: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" /> },
    { to: "/admin/vouchers", label: "Vouchers", icon: "local_offer", svg: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /> },
    { to: "/admin/wheel", label: "Vòng quay", isMaterial: true, iconName: "rocket_launch" },
    { to: "/admin/policies", label: "Chính sách", isMaterial: true, iconName: "policy" },
    { to: "/admin/brands", label: "Quản lý Thương hiệu", isMaterial: true, iconName: "branding_watermark" },
    { to: "/admin/reviews", label: "Quản lý Reviews", isMaterial: true, iconName: "rate_review" },
    { to: "/admin/footer", label: "Quản lý Footer", isMaterial: true, iconName: "vertical_align_bottom" },
    { to: "/admin/homepage", label: "Quản lý Trang chủ", isMaterial: true, iconName: "home_app_logo" },
    { to: "/admin/payment", label: "Quản lý Thanh toán", isMaterial: true, iconName: "payments" },
    { to: "/admin/banners", label: "Quản lý Banner", isMaterial: true, iconName: "ad_units" },
    { to: "/admin/supplies", label: "Kho phụ liệu", isMaterial: true, iconName: "inventory" },
    { to: "/", label: "Xem trang web", icon: "public", svg: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /> },
  ];

  if (user.role !== "manager") {
    menuItems.splice(3, 0, { to: "/admin/users", label: "Người dùng", icon: "group", svg: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" /> });
  }

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden font-inter">
      {/* Mobile Header */}
      <div className="lg:hidden fixed top-0 left-0 right-0 h-16 bg-slate-900 flex items-center justify-between px-4 z-[50] shadow-lg">
        <button onClick={() => setSidebarOpen(true)} className="text-white p-2">
          <span className="material-symbols-outlined text-[28px]">menu</span>
        </button>
        <h1 className="text-lg font-black text-white">TaHa <span className="text-red-500">Shoes</span> Admin</h1>
        <div className="w-10"></div>
      </div>

      {/* Backdrop */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[60] lg:hidden transition-all animate-fadeIn"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 w-72 bg-slate-900 text-white z-[70] transform transition-transform duration-300 ease-in-out lg:relative lg:translate-x-0
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
      `}>
        <div className="p-6 border-b border-slate-800">
          <div className="flex items-center justify-between mb-2">
            <h1 className="text-2xl font-black text-white tracking-tight">
              TaHa <span className="text-red-500">Shoes</span>
            </h1>
            <button onClick={() => setSidebarOpen(false)} className="lg:hidden text-slate-400">
              <span className="material-symbols-outlined">close</span>
            </button>
          </div>
          <div className="flex items-center gap-3 py-4 mt-2">
            <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center font-bold text-white shadow-lg">
              {user.name?.charAt(0) || "A"}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-black truncate">{user.name || "Admin"}</p>
              <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">{user.role || "Administrator"}</p>
            </div>
          </div>
        </div>

        <nav className="p-4 space-y-1 overflow-y-auto max-h-[calc(100vh-200px)]">
          {menuItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={() => setSidebarOpen(false)}
              className="flex items-center px-4 py-3 rounded-xl hover:bg-slate-800 transition-all group font-bold text-[13px] text-slate-400 hover:text-white"
            >
              {item.isMaterial ? (
                <span className="material-symbols-outlined mr-3 text-[20px] group-hover:scale-110 transition-transform">{item.iconName}</span>
              ) : (
                <svg className="w-5 h-5 mr-3 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  {item.svg}
                </svg>
              )}
              <span className="flex-1">{item.label}</span>
              {item.badge > 0 && (
                <span className="bg-red-500 text-white text-[10px] font-black px-1.5 py-0.5 rounded-full min-w-[20px] text-center shadow-lg shadow-red-500/20 animate-pulse">
                  {item.badge > 99 ? "99+" : item.badge}
                </span>
              )}
            </Link>
          ))}

          <button
            onClick={handleLogout}
            className="flex items-center w-full px-4 py-3 rounded-xl hover:bg-red-600/10 text-red-500 transition-all font-bold text-[13px] mt-8 group"
          >
            <svg className="w-5 h-5 mr-3 group-hover:rotate-12 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            Đăng xuất
          </button>
        </nav>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto pt-16 lg:pt-0">
        <div className="max-w-[1600px] mx-auto min-h-full">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
